export default () => ({
    isLoading: true,
    status: {},
    user: null
})